import { forwardRef } from "react";

interface InputSelectProps {
    label: string;
    name: string;
    address?: string;   
    error?: string;
    data: { value: string; label: string; address?: string }[];
    value?: string | null;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur?: () => void;
    isDisabled?: boolean;
    inputStyle?: string;
}

const InputSelect = forwardRef<HTMLSelectElement, InputSelectProps>(
    ({ label, name, data, error, value = "", onChange, onBlur, isDisabled = false, inputStyle }, ref) => {
        const id = `input-${name}`;
        console.log("Data",data);
        return (
            <div className="flex flex-col w-full items-start">
                <label htmlFor={id} className="font-medium mb-[4px]">{label}</label>
                <select
                    ref={ref}
                    id={id}
                    disabled={isDisabled}
                    name={name}
                    value={value ?? ""}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={`${isDisabled ? 'opacity-45' : 'opacity-100'} outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 max-h-[46px] ${inputStyle ? inputStyle : ""}`}
                >
                    <option value="">Chọn</option>
                    {data.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.address ? `${item.label} - ${item.address}` : item.label}
                        </option>
                    ))}
                </select>
                <div className="h-[20px] mt-1">
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                </div>            </div>
        );
    }
);

export default InputSelect;
